import { render, staticRenderFns } from "./AdicionarEmpresa.vue?vue&type=template&id=98ddbbb0&scoped=true"
import script from "./AdicionarEmpresa.vue?vue&type=script&lang=js"
export * from "./AdicionarEmpresa.vue?vue&type=script&lang=js"
import style0 from "./AdicionarEmpresa.vue?vue&type=style&index=0&id=98ddbbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ddbbb0",
  null
  
)

export default component.exports